import { DataFetchingClient } from 'data-fetching-client';
import { mergeSidebarNotifications, SIDEBAR_NOTIFICATIONS_QUERY_NAME } from '../channels/sidebar/SidebarV2/queries/SidebarNotificationQuery';
export const createNotificationsDataFetchingClient = () => {
  return new DataFetchingClient({
    queryFieldPolicies: {
      [SIDEBAR_NOTIFICATIONS_QUERY_NAME]: {
        /**
         * These keys identify arguments that are to be considered as part
         * of the cache key for the infinite query. Any changes to these keys
         * should result in a different query being referenced. Changes to arguments
         * not in this list will be considered additional data for an existing query
         * e.g. fetching more pages in this case.
         */
        keyArgs: ['filterOption', 'sidebarTabState'],
        merge: mergeSidebarNotifications
      }
    }
  });
};